module.exports = __webpack_public_path__ + "static/media/small.9519a053.png";